document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'object') {
    gsap.registerPlugin(MorphSVGPlugin);

    var morphTimeline = gsap.timeline({
      repeat: -1,
      repeatDelay: 3,
      delay: 4,
    });

    MorphSVGPlugin.defaultMap = 'complexity';
    MorphSVGPlugin.dfaultType = 'rotational';

    morphTimeline
      .timeScale(1.5)
      .to('#slide-1', 1, {
        morphSVG: { shape: '#slide-2' },
        opacity: 1,
      })
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-3' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-4' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-5' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-6' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-7' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-8' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-9' } }, '+=3')
      .to('#slide-1', 1, { morphSVG: { shape: '#slide-1' } }, '+=3');
  }
});
